import { Card } from '@components/primitives/Card.js'
import { Badge } from '@components/primitives/Badge.js'
import { formatCurrency } from '@utils/format.js'
import type { ObraConfig } from '@services/db.js'
import { TIPO_CONTRATACAO } from './types.js'

interface Props {
  config: ObraConfig
  onEdit: () => void
}

export function DadosObraSection({ config, onEdit }: Props) {
  return (
    <Card surface='raised'>
      <div className='cf3-config-section'>
        <div className='cf3-config-section__header'>
          <p className='cf3-config-section__title'>Dados da Obra</p>
          <button type='button' className='cf3-config-section__link' onClick={onEdit}>
            Editar
          </button>
        </div>

        <dl className='cf3-config-list'>
          <div className='cf3-config-list__item'>
            <dt>Nome</dt>
            <dd>{config.nome}</dd>
          </div>
          <div className='cf3-config-list__item'>
            <dt>Início</dt>
            <dd>{config.dataInicio}</dd>
          </div>
          <div className='cf3-config-list__item'>
            <dt>Área Total</dt>
            <dd>{config.areaTotal} m²</dd>
          </div>
          <div className='cf3-config-list__item'>
            <dt>Padrão</dt>
            <dd>
              <Badge label={config.padraoConstrucao} variant='info' size='sm' />
            </dd>
          </div>
          <div className='cf3-config-list__item'>
            <dt>Orçamento</dt>
            <dd>{formatCurrency(config.orcamentoTotal)}</dd>
          </div>
          {config.regiao && (
            <div className='cf3-config-list__item'>
              <dt>Região</dt>
              <dd>{config.regiao}</dd>
            </div>
          )}
          {config.tipoContratacao && (
            <div className='cf3-config-list__item'>
              <dt>Contratação</dt>
              <dd>
                {TIPO_CONTRATACAO.find((t) => t.value === config.tipoContratacao)?.label ??
                  config.tipoContratacao}
              </dd>
            </div>
          )}
        </dl>
      </div>
    </Card>
  )
}
